import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import { green } from '@material-ui/core/colors';
import PropTypes from 'prop-types';

const styles = () => ({
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

const Component = ({ classes, ...rest }) => (
  <CircularProgress className={classes.buttonProgress} {...rest} />
);

Component.propTypes = {
  classes: PropTypes.shape({
    buttonProgress: PropTypes.object,  // eslint-disable-line
  }).isRequired,
};

export default withStyles(styles)(Component);
